import React, { useRef } from 'react';
export function VideoTestimonials() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -320 : 320,
        behavior: 'smooth'
      });
    }
  };
  const videos = [{
    name: 'Silvia R.',
    location: 'Buenos Aires'
  }, {
    name: 'Graciela M.',
    location: 'Córdoba'
  }, {
    name: 'Patricia L.',
    location: 'Rosario'
  }];
  return <div className="bg-brand-ink py-16 px-6" data-id="element-342">
      <div className="max-w-[960px] mx-auto" data-id="element-343">
        <span className="block text-[11px] font-bold tracking-[3px] uppercase text-brand-green text-center mb-2.5" data-id="element-344">
          🎥 Escuchá directo de quienes vivieron la transformación
        </span>
        <h2 className="font-display text-[22px] sm:text-[3.5vw] md:text-[38px] text-center text-white mb-2 uppercase" data-id="element-345">
          Dale play y mirá lo que dicen
        </h2>
        <div className="green-divider" data-id="element-346"></div>

        <div className="relative" data-id="element-347">
          <div ref={scrollRef} className="flex gap-5 overflow-x-auto pb-3 scroll-smooth scrollbar-thin scrollbar-thumb-brand-green scrollbar-track-[#222]" style={{
          scrollbarWidth: 'thin',
          scrollbarColor: '#00c853 #222'
        }} data-id="element-348">
            {videos.map((video, i) => <div key={i} className="flex-none w-[300px] bg-[#1a1a1a] border border-brand-border rounded-xl overflow-hidden" data-id="element-349">
                <div className="h-[200px] bg-[#111] flex items-center justify-center" data-id="element-350">
                  <div className="w-14 h-14 bg-brand-green/15 border-2 border-brand-green rounded-full flex items-center justify-center cursor-pointer" data-id="element-351">
                    <div className="w-0 h-0 border-t-[12px] border-t-transparent border-b-[12px] border-b-transparent border-l-[20px] border-l-brand-green ml-1" data-id="element-352"></div>
                  </div>
                </div>
                <div className="py-3.5 px-4" data-id="element-353">
                  <p className="font-display text-[15px] text-white mb-0.5 uppercase" data-id="element-354">
                    {video.name}
                  </p>
                  <p className="text-[12px] text-brand-muted" data-id="element-355">
                    📍 {video.location}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="flex justify-center gap-3 mt-4" data-id="element-356">
            <button onClick={() => scroll('left')} className="bg-white/5 border border-white/15 text-white w-9 h-9 rounded-full flex items-center justify-center text-lg hover:bg-brand-green/40 transition-colors" data-id="element-357">
              &#8249;
            </button>
            <button onClick={() => scroll('right')} className="bg-white/5 border border-white/15 text-white w-9 h-9 rounded-full flex items-center justify-center text-lg hover:bg-brand-green/40 transition-colors" data-id="element-358">
              &#8250;
            </button>
          </div>
        </div>

        <div className="bg-brand-gold/5 border border-brand-gold/20 rounded-lg p-4 mt-5 text-[12px] text-white/50 text-center" data-id="element-359">
          <p data-id="element-360">
            📌 <strong className="text-brand-gold" data-id="element-361">Para agregar videos:</strong>{' '}
            Reemplazar <code data-id="element-362">.video-thumb-area</code> de cada item por{' '}
            <code data-id="element-363">
              &lt;iframe src="https://www.youtube.com/embed/ID" width="300"
              height="200" frameborder="0" allowfullscreen&gt;&lt;/iframe&gt;
            </code>
          </p>
        </div>
      </div>
    </div>;
}